'use client';

import React__default from 'react';
import { ButtonAIWrapper, Text } from './ButtonAI.css.js';

var ButtonAI = function (props) {
    var style = props.style;
    return (React__default.createElement(ButtonAIWrapper, { onClick: function () { return props.onClick && props.onClick(); }, style: style },
        React__default.createElement(Text, null, props.children)));
};

export { ButtonAI as default };
//# sourceMappingURL=index.js.map
